import { useMedia } from "dsl/atoms/ResponsiveMedia";
import { useMatch } from "react-router-dom";
import useProductTour, { PRODUCT_TOURS } from "../..";

export const useShowReceiverSettingsTour = () => {
  const { isTablet } = useMedia();
  const isReverseSearchPage = useMatch(
    `/careprovider/dashboard/:careproviderId/settings/search`,
  );

  useProductTour({
    tour: PRODUCT_TOURS.receiver_settings,
    skip: !!isReverseSearchPage || isTablet,
  });
};
